module.exports = __webpack_public_path__ + "static/Talkspace-70546b3a5c5f65f78e0c06fa1f87882a.jpg";